const common = {
  list: 'list',
  detail: 'detail',
  create: 'create',
  edit: 'edit',
  delete: 'delete'
};
export default common;
